import React, { memo } from 'react';
import { Row, Col } from 'react-bootstrap';
import { loan_types, status_code_list } from '../Const';

interface Props {
  reception_id: number;
  status_code: number;
  has_debtor?: boolean;
  reception_cd: string;
}

// KWANKGM04270_近代化資金借入申込 確認のフッターボタン群
// KWANKGM04240_借入申込希望書兼経営改善資金計画書 確認のフッターボタン群
const ModernizationFundsExaminationFinalConfirmationFooter: React.FC<Props> = ({
  reception_id,
  status_code,
  has_debtor,
  reception_cd,
}) => {
  const url = new URL(window.location.href);
  const item_id = url.searchParams.get('item_id');

  /**
   * KWANKGM00180_メール再送画面 へ遷移
   */
  const handleClickResendMail = () => {
    location.replace(
      `${location.origin}${process.env.MIX_MOCK_URL}/applicant/mail_resend?r_id=${reception_id}`
    );
  };

  // 「戻る」ボタン押下時
  const backTransition = () => {
    location.replace(
      `${location.origin}${process.env.MIX_MOCK_URL}/reception/${reception_cd}/${reception_id}/${status_code}`
    );
  };

  /**
   * 『連帯債務者等の方へ確認依頼メールを再送する』ボタンを表示する
   * ローンが近代化資金_借入申込 かつ 連帯債務者等が存在する場合で、下記案件ステータスで表示・非表示の制御を行う
   *
   * ・案件ステータスが借入申込保証人確認中～借入申込連携待ちの場合に表示
   * ・案件ステータスが借入申込保証人不同意の場合は非表示
   */
  const jsxElementResendMail = () => {
    if (item_id !== loan_types.modernization_funds) {
      return null;
    }

    if (!has_debtor) {
      return null;
    }

    if (status_code === status_code_list.borrowing_application_disagreement) {
      return null;
    }

    if (
      !(
        status_code >= status_code_list.borrowing_application_check &&
        status_code <= status_code_list.borrowing_application_waiting_mdn
      )
    ) {
      return null;
    }

    return (
      <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-no-arrow">
        <div className="text-right sp-button-center">
          <a className="btn btn-xl btn-main-color" onClick={handleClickResendMail}>
            連帯債務者等の方へ
            <br className="d-lg-none" />
            確認依頼メールを再送する
          </a>
        </div>
      </Col>
    );
  };

  /**
   *「戻る」「連帯債務者等の方へ確認依頼メールを再送する」ボタンを出力する
   */
  const outPutButton = () => {
    return (
      <>
        <Row className="my-5 flex-lg-row flex-md-reverse flex-sm-column-reverse flex-column-reverse">
          <Col xl={6} lg={6} md={6} sm={6} xs={12} className="row-left-button-arrow">
            <div className="text-left">
              <a className="btn btn-xl btn-main-color" onClick={backTransition}>
                戻る
              </a>
            </div>
          </Col>
          {jsxElementResendMail()}
        </Row>
      </>
    );
  };

  return <>{outPutButton()}</>;
};

export default memo(ModernizationFundsExaminationFinalConfirmationFooter);
